module.exports = __webpack_public_path__ + "static/img/5.d2fe62d.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/active/sakura/sanliouLinkage/third/5.png
// module id = jNwd
// module chunks = 6